import React from "react"
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import type { CreateableBannerType } from "types/cms"
import { cmsPageClick } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import { cleanTitle } from "components/Contentful/RichTextRenderer/RichTextRenderer.utils"
import { navigateTo } from "utils/navigateTo"

import { container } from "./CreateableBanner.css"
import { CreateableBannerContent } from "./Content"

type Props = CreateableBannerType & CMSPageProps

export const CreateableBanner: React.FC<Props> = (props) => {
  const { bannerLink, trackingModule, id } = props
  if (!bannerLink) {
    return (
      <div className={container} data-testid={cleanTitle(`${id} component`)}>
        <CreateableBannerContent {...props} />
      </div>
    )
  }
  const handleClick = () => {
    cmsPageClick({
      ...trackingModule,
      moduleContentUrl: bannerLink.href ?? bannerLink.url,
      moduleContentDetails: "hero_banner_clicked",
    })
    navigateTo(bannerLink.href ?? bannerLink.url)
  }
  return (
    <div
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(bannerLink && {
        onClick: handleClick,
        style: { cursor: "pointer" },
      })}
      className={container}
      data-testid={cleanTitle(`${id} component`)}
    >
      <CreateableBannerContent {...props} />
    </div>
  )
}
